export default function isSas(pathname) {
  return pathname?.includes('/supplementary-card/')
    || pathname?.includes('/supplementary/');
}
